import { FC } from "react";
import { useLanguage } from "../../context/LanguageContext";
import BenefitsImage from "../../assets/guru-guides-memory-page.png";
import { BreadCrumbHeading, LandingHeader, LandingSection } from "../../compositions/LandingPage";
import Video from "../../components/Video";
import styles from "./index.module.css";

const ListContent: FC = () => {
  const { t } = useLanguage();
  return (
    <>
      <LandingSection>
        <mui-heading level="2" size="4" style={{ "--heading-text-color": "var(--theme-selected)" }}>
          {t("guides.benefits-page.performance.title")}
        </mui-heading>
        <img className={styles.image} src={BenefitsImage} alt="Memory" />

        <mui-list as="ol" class={styles.list}>
          <mui-list-item size="small">{t("guides.benefits-page.performance.item-one")}</mui-list-item>
          <mui-list-item size="small">{t("guides.benefits-page.performance.item-two")}</mui-list-item>
          <mui-list-item size="small">{t("guides.benefits-page.performance.item-three")}</mui-list-item>
        </mui-list>
      </LandingSection>

      <LandingSection>
        <mui-heading level="2" size="4" style={{ "--heading-text-color": "var(--theme-selected)" }}>
          {t("guides.benefits-page.access.title")}
        </mui-heading>
        <Video videoId="l2AYGcQ60OQ?si=OV_tvXPX-uQbNvQH" />

        <mui-list as="ol" class={styles.list}>
          <mui-list-item size="small">{t("guides.benefits-page.access.item-one")}</mui-list-item>
          <mui-list-item size="small">{t("guides.benefits-page.access.item-two")}</mui-list-item>
          <mui-list-item size="small">{t("guides.benefits-page.access.item-three")}</mui-list-item>
        </mui-list>
      </LandingSection>

      <LandingSection>
        <mui-heading level="2" size="4" style={{ "--heading-text-color": "var(--theme-selected)" }}>
          {t("guides.benefits-page.customisable.title")}
        </mui-heading>
        <Video videoId="YoKhzXeyPOA?si=HldNXd22qDqJVOo6" />

        <mui-list as="ol" class={styles.list}>
          <mui-list-item size="small">{t("guides.benefits-page.customisable.item-one")}</mui-list-item>
          <mui-list-item size="small">
            <mui-link size="small" href="/guides/customise">
              {t("guides.benefits-page.customisable.item-two")}
            </mui-link>
          </mui-list-item>
        </mui-list>
      </LandingSection>
    </>
  );
};

export const Benefits: FC<{}> = () => {
  const { t } = useLanguage();
  return (
    <>
      <BreadCrumbHeading link={t("guides.title")} to="/guides" page={t("guides.benefits-page.title")} />

      <LandingHeader>
        <mui-heading level="1">{t("guides.benefits-page.title")}</mui-heading>
        <mui-body size="large" style={{ maxWidth: "65ch" }}>
          {t("guides.benefits-page.description")}
        </mui-body>
      </LandingHeader>
      <mui-responsive breakpoint="920">
        <mui-grid slot="showBelow" space="var(--space-800)" col="1fr">
          <ListContent />
        </mui-grid>
        <mui-grid slot="showAbove" space="var(--space-800)" col="1fr 1fr">
          <ListContent />
        </mui-grid>
      </mui-responsive>
    </>
  );
};

export default Benefits;
